import React, {Component} from 'react'
import Dropzone from 'react-dropzone'
import Select from "react-select"
import {isNull, validatePhone, validateEmail, ifPhoneNumberRegistered} from "./utils";
import styles from './styles.module.scss'
const HOST = "http://www.xiniudata.com/";

const showNames = ['name', 'phone', 'wechat', 'email', 'orgName', 'position', 'userRole'];
interface Iprops {
  showName: string,
  name: string,
  value?: string,
  required: boolean,
  prompt: string,
  id: string,
  showVerify: string,
  onChange: (name: string, value: string) => void
  uploadCard: (gridId: string) => void
}

interface Istate {
  showValidate: boolean,
  validate: string,
  gridId: string,
  code: string,
}
export class InputItem extends Component<Iprops, Istate>{
  constructor(props){
    super(props);
    this.change = this.change.bind(this)
    this.blur = this.blur.bind(this)
    this.uploadCard = this.uploadCard.bind(this);
    this.state ={
      showValidate: false,
      validate: '',
      gridId: '',
      code: '',
    }
  }

  change(e) {
    let name = e.target.name;
    let value = e.target.value;
    this.props.onChange(name, value)

    if (e.target.value != '') {
      this.setState({validate: '', showValidate: false});
    }

    if(e.target.name == 'userRole') {
      document.getElementById("select_userRole").style.color = "black";
    }
  }


  uploadCard(gridId){
    this.props.uploadCard(gridId);
  }

  async blur(e){
    let {showName, name, value} = this.props;
    if(showNames.includes(name)){
      if(isNull(value)) {
        this.setState({validate: `${showName}不能为空`, showValidate: true});
        return;
      }
      else if(name == 'phone') {
        let verifyPhoneResult = await ifPhoneNumberRegistered(value);
        if (!validatePhone(value)) {
          this.setState({validate: '手机格式错误，请重新输入',showValidate: true});
        } else if(verifyPhoneResult.code == 0 && verifyPhoneResult.plain_result){
          this.setState({validate: '手机号码已经申请过试用，请重新输入',showValidate: true});
        }else{
          this.setState({validate: '',showValidate: false});
        }
      }
      else if(name == 'email') {
        if (!validateEmail(value)) {
          this.setState({validate: '邮箱格式错误，请重新输入',showValidate: true});
        }
        else{
          this.setState({validate: '',showValidate: false});
        }
      }
      else{
        this.setState({validate: '',showValidate: false});
      }
    }
  }

  onDrop = async (files) => {
    let file = files[0];
    // let {name} = file;
    let fd = new FormData();
    fd.append('file', file);

    let res = await this.upload(fd);
    if(res) {
      let {gridId,code} = res;

      this.setState({
        gridId: gridId,
        code: code,
      }, () => {
        this.uploadCard(this.state.gridId);
      });
    } else {
      this.setState({
        code: '-1',
      })
    }

  }

  upload = async (file) =>{
    return await fetch(`/api2/service/x_service/person_file/upload`, {
      method: 'POST',
      body: file // This is your file object
    }).then(
      response => response.json()
    ).then(
      success => success
    ).catch(
      error => console.log(error) // Handle the error response object
    );
  };

  render(){
    let {showName, name, value,required,prompt,id,showVerify} = this.props;

    let {validate,showValidate,gridId,code} = this.state;
    // @ts-ignore
    return (
      <div className={styles.form_item}>
        <div className={styles.form_right}>
          {name==="cardId"?
            <div className={`${styles.input_item} ${styles.input_item2}`}>
              <Dropzone accept={{"image/*": [".png", ".jpeg", ".jpg"]}} onDrop={this.onDrop} maxSize={2097152}>
                {({getRootProps, getInputProps}) => (
                  <div className={styles.dropzone} {...getRootProps()}>
                    <input {...getInputProps()} style={{display: "none"}}/>
                    <div className={styles.uploadContent}>
                      {
                        code === ''? <div className={styles.uploadTip}>
                            <p>上传名片</p>
                            <span>支持格式：jpg、png，不超过2MB</span>
                          </div> :
                          code == '0' ? <><p style={{alignSelf: "flex-start", marginLeft: "16px", color: "#858A99"}}>上传名片</p><img src={`${HOST}file/${gridId}`} /></>:
                            code == '-1' ?
                              <div className={styles.cardFormatError}>
                                <div className={styles.cardFormatErrorTip}>!</div>
                                <div>名片格式错误，请重新上传(不超过2MB)</div>
                              </div>
                              : null
                      }
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
            :
            name === 'userRole' ?
              <div className={styles.input_item}>
                <select name={name} onChange={this.change} id='select_userRole' style={{color: "#858A99"}} onBlur={this.blur} className={showValidate || showVerify == name ? styles.showValidate: null}>
                  <option value ="">{prompt}*</option>
                  <option value ="投资人">投资人</option>
                  <option value="FA/投行">FA/投行</option>
                  <option value="母基金/引导基金/其他LP">母基金/引导基金/其他LP</option>
                  <option value="创业者/企业高管">创业者/企业高管</option>
                  <option value="专业服务机构">专业服务机构</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              :
              <div className={styles.input_item}>
                <input name={name} value={value} onChange={this.change} placeholder={`${showName}${required ? "*":""}`} onBlur={this.blur}
                       id={id} autoComplete="off"
                       className={showValidate || showVerify == name ? styles.showValidate: null}/>
                {showValidate? <div className={styles.inputValidate}>{validate}</div>: null }
              </div>
          }
        </div>
      </div>
    )
  }
}





